<template>
    <div class="login page-view">
        <div class="login-form">
            <ejs-textbox id='usr' floatLabelType="Auto" placeholder="Korisnicko ime" width="100%"></ejs-textbox>
            <ejs-textbox id='pwd' floatLabelType="Auto" type="password" placeholder="Lozinka" width="100%"></ejs-textbox>
            <ejs-checkbox ref="check" label='Zapamti' :checked="this.$store.state.rememberLogin"></ejs-checkbox>
            <ejs-button class="btn-prijava" v-on:click.native='onPrijava'>PRIJAVI SE</ejs-button>
        </div>
    </div>
</template>

<style lang="scss">
.login-form {
    width: 60%;
    max-width: 300px;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 300px;
    padding: 35px;
    background-color: #FFF;
    border-radius: 6px;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.4);
    border-top: solid 4px #CC3232;
}
.btn-prijava {
    display: block;
    margin-top: 10px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
</style>

<script>
export default {
    name: 'login',
    data() {
        return {

        }
    },
    methods: {
        onPrijava() {
            let usr = document.getElementById('usr');
            let pwd = document.getElementById('pwd');
            const payload = {
                Username: usr.value,
                Password: pwd.value
            }
            this.$store.dispatch('login', payload)
            .then(res => {
                let c = this.$refs.check.$el.checked;
                if (c) {
                    localStorage.token = this.$store.state.token;
                    localStorage.rememberLogin = this.$store.state.rememberLogin;
                } else {
                    localStorage.removeItem("token");
                    localStorage.removeItem("rememberLogin");
                }
                this.$router.push('flota');
            })
            .catch(err => this.$parent.showNotification(err));
        }
    },
    mounted() {
        this.$store.state.hideSettingIcon = true;
        this.$store.state.hideCloseIcon = true;
        this.$store.state.hideReturnIcon = true;
        this.$store.state.hideFloatWidgetRight = true;
        this.$store.state.viewTitle = 'mFleet';
    }
}
</script>